import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import * as React from "react";
export default function CustomCheckBox({ value, onChange, title, id, disabled }) {
  return (
    <FormControlLabel
      sx={{
        "&.MuiFormControlLabel-label": {
          fontSize: "14px",
          "@media (max-width: 960px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& .css-ahj2mt-MuiTypography-root": {
          fontSize: "14px",
          "@media (max-width: 960px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
      }}
      disabled={disabled}
      control={
        <Checkbox id={id} checked={value} onChange={onChange}
          sx={{
            color: "black",
            "&.Mui-checked": {
              color: "#c4960c",
            },
            "& .MuiSvgIcon-root": {
              fontSize: "20px",
              "@media (max-width: 960px)": {
                fontSize: "16px",
              },
              "@media (max-width: 687px)": {
                fontSize: "14px",
              },
            },
          }}
        />
      }
      label={<Typography sx={{ typography: { sm: 'h6', xs: 'body2' }, color: "black" }}>{title}</Typography>}
    />
  );
}
